// extracted by mini-css-extract-plugin
export default {"game":"Game_game__7o0X5","action":"Game_action__gzov7","action-blue":"Game_action-blue__jZgqJ","action-red":"Game_action-red__vMPO3","action-over":"Game_action-over__yHBGz"};